import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home: React.FC = () => {
  const [scrollY, setScrollY] = useState(0);
  const [galleryImages, setGalleryImages] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);

    // Fetch gallery images from backend
    const fetchGalleryImages = async () => {
      try {
        const response = await fetch('http://localhost:5000/api/gallery');
        if (response.ok) {
          const data = await response.json();
          setGalleryImages(data.images || []);
        }
      } catch (error) {
        console.error('Error fetching gallery images:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchGalleryImages();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Helper function to get image URL
  const getImageUrl = (imagePath: string) => {
    if (imagePath.startsWith('http')) {
      return imagePath;
    }
    return `http://localhost:5000${imagePath}`;
  };

  // Fallback images
  const heroImage = "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?q=80&w=2053&auto=format&fit=crop"; // Modern Lux Interior
  
  // Sample pictures for the landing page (static samples as requested)
  const sampleImages = [
    {
      id: 1,
      src: `${process.env.PUBLIC_URL}/images/Nappali.png`,
    },
    {
      id: 2,
      src: `${process.env.PUBLIC_URL}/images/szobafestes.png`,
    }
  ];

  return (
    <div className="home">
      {/* Hero Section - Full Screen with Background Image */}
      <section className="hero-section" style={{ backgroundImage: `url(${heroImage})` }}>
        <div className="hero-overlay"></div>
        <div className="hero-content fade-in-up">
          <h1 className="hero-title">Lakics Márk</h1>
          <h2 className="hero-subtitle">Professzionális Szobafestés & Felújítás</h2>
          <p className="hero-text">Győr • Környéke</p>
          <div className="hero-buttons">
            <Link to="/kapcsolat" className="btn btn-primary">Ajánlatkérés</Link>
            <Link to="/galeria" className="btn btn-secondary">Munkáim</Link>
          </div>
        </div>
      </section>

      {/* Intro Section - Minimalist */}
      <section className="section intro-section">
        <div className="container">
          <div className="content-grid">
            <div className="text-content">
              <h2 className="section-title">Minőség. Precizitás. Megbízhatóság.</h2>
              <p className="section-desc">
                Otthona megérdemli a törődést. Több mint 10 éves tapasztalattal vállalom lakások, házak és irodák teljes körű festését és felújítását. 
                Prémium anyagok, modern technológiák és garantált határidők.
              </p>
              <ul className="feature-list">
                <li>✨ Pormentes csiszolás</li>
                <li>🎨 Prémium festékek</li>
                <li>🛡️ Garancia minden munkára</li>
                <li>🧹 Tiszta átadás</li>
              </ul>
            </div>
            <div className="image-content">
               <img src={`${process.env.PUBLIC_URL}/images/beforeafter.png`} alt="Professional Painting" className="rounded-image shadow-lg" />
            </div>
          </div>
        </div>
      </section>

      {/* Featured Projects - Tesla Style Cards */}
      <section className="section featured-section">
        <div className="container">
          <h2 className="section-title center">Kiemelt Munkák</h2>
          <div className="project-grid">
            {sampleImages.map((img) => (
              <div key={img.id} className="project-card">
                <div className="card-image-wrapper">
                  <img src={img.src}  />
                  <div className="card-overlay">
                    
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div className="center mt-4">
             <Link to="/galeria" className="btn btn-outline">Összes munka megtekintése</Link>
          </div>
        </div>
      </section>

      {/* Services - Clean Grid */}
      <section className="section services-section bg-dark">
        <div className="container">
          <h2 className="section-title center text-white">Szolgáltatások</h2>
          <div className="services-grid-clean">
             <div className="service-item">
                <div className="service-icon">🏠</div>
                <h3>Belső Festés</h3>
                <p>Teljes körű falfestés, tisztasági festés, színtervezés.</p>
             </div>
             <div className="service-item">
                <div className="service-icon">🎨</div>
                <h3>Tapétázás</h3>
                <p>Minőségi tapétázás, poszterek és dekorfalak készítése.</p>
             </div>
             <div className="service-item">
                <div className="service-icon">🔨</div>
                <h3>Glettelés</h3>
                <p>Tükörsima felületek előkészítése Q3-Q4 minőségben.</p>
             </div>
             <div className="service-item">
                <div className="service-icon">✨</div>
                <h3>Díszítő Festés</h3>
                <p>Egyedi stílusok, márvány hatás, beton hatás, strukturált felületek.</p>
             </div>
          </div>
        </div>
      </section>

      {/* Call to Action - Parallax */}
      <section className="cta-section" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/images/LandingPageHero2.png)` }}>
        <div className="hero-overlay"></div>
        <div className="cta-content fade-in-up">
           <h2>Álmodja meg, mi megvalósítjuk</h2>
           <p>Ingyenes felmérés és árajánlat 48 órán belül.</p>
           <Link to="/kapcsolat" className="btn btn-primary">Kapcsolatfelvétel</Link>
        </div>
      </section>
    </div>
  );
};

export default Home;
